"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find-index");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _EmailEnv = require("@/api/EmailEnv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ConfigLevel',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
        code: undefined,
        sort: 'id',
        order: 'desc',
        type: undefined,
        status: undefined
      },
      sceneList: [],
      multipleSelection: [],
      activeName: 'zh',
      listConfig: [{
        label: "特急",
        type: 'danger',
        value: 4
      }, {
        label: "紧急",
        type: 'warning',
        value: 3
      }, {
        label: "常规",
        type: 'success',
        value: 2
      }, {
        label: "一般",
        type: 'defalut',
        value: 1
      }]
    };
  },
  created: function created() {
    this.getList();
  },
  computed: {
    getType: function getType() {
      return function (type) {
        var index = this.listConfig.findIndex(function (item) {
          return item.value == type;
        });
        if (index >= 0) {
          return this.listConfig[index];
        }
      };
    }
  },
  methods: {
    handleAdd: function () {
      var _handleAdd = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(row) {
        var reg, obj, fn, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              reg = /[\d,_,\w]+/;
              if (reg.test(row.code)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.$message.error('编码不能为空'));
            case 1:
              if (row.type) {
                _context.n = 2;
                break;
              }
              return _context.a(2, this.$message.error('请选择紧急程度'));
            case 2:
              if (row.name) {
                _context.n = 3;
                break;
              }
              return _context.a(2, this.$message.error('请输入应用场景名称'));
            case 3:
              _context.p = 3;
              row.loading = true;
              obj = {
                code: row.code,
                type: row.type,
                name: row.name,
                status: row.status,
                id: row.id
              };
              fn = row.id ? _EmailEnv.update : _EmailEnv.save;
              _context.n = 4;
              return fn(obj);
            case 4:
              res = _context.v;
              if (res.data.errno == 0) {
                row.isEdit = false;
                this.getList();
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
            case 6:
              _context.p = 6;
              row.loading = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5, 6, 7]]);
      }));
      function handleAdd(_x) {
        return _handleAdd.apply(this, arguments);
      }
      return handleAdd;
    }(),
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    reset: function reset() {
      this.listQuery = {
        page: 1,
        limit: 20,
        name: undefined,
        code: undefined,
        type: undefined,
        status: undefined
      };
      this.getList();
    },
    // 获取列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _EmailEnv.getList)((0, _objectSpread2.default)({}, this.listQuery)).then(function (response) {
        _this.list = response.data.data.list;
        _this.total = response.data.data.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.list = [];
        _this.listLoading = false;
      });
    },
    // 新增
    handleCreate: function handleCreate() {
      var obj = {
        code: null,
        name: null,
        type: null,
        status: 1,
        isEdit: true,
        loading: false
      };
      var list = JSON.parse(JSON.stringify(this.list));
      list.unshift(obj);
      this.list = list;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 修改
    handleUpdate: function handleUpdate(row) {
      this.$set(row, 'isEdit', false);
      row.isEdit = true;
    },
    onEnable: function onEnable(val, value) {
      var _this2 = this;
      console.log(val, 'valsdfds');
      (0, _EmailEnv.update)({
        id: value.id,
        status: val
      }).then(function () {
        _this2.getList();
        _this2.$notify.success({
          title: '成功',
          message: '修改成功'
        });
      }).catch(function (response) {
        var status = value.status == 1 ? 0 : 1;
        _this2.$set(value, 'status', status);
        _this2.$message.error(response.data.errmsg);
      });
    },
    handleSetConfig: function handleSetConfig() {
      this.$router.push();
    },
    // 删除
    handleDeleteMore: function handleDeleteMore() {
      var _this3 = this;
      if (this.multipleSelection.length === 0) return this.$message.error('请选择你要删除的模板');
      var ids = this.multipleSelection.map(function (ele) {
        return ele.id;
      }).join(',');
      this.$confirm('是否要进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteEmailTemplate({
          ids: ids
        }).then(function () {
          _this3.getList();
          _this3.$notify.success({
            title: '成功',
            message: '删除成功'
          });
        }).catch(function (response) {
          _this3.$message.error(response.data.errmsg);
        });
      }).catch(function () {});
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('是否要进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _EmailEnv.del)({
          id: row.id
        }).then(function () {
          _this4.getList();
          _this4.$notify.success({
            title: '成功',
            message: '删除成功'
          });
        }).catch(function (response) {
          _this4.$message.error(response.data.errmsg);
        });
      }).catch(function () {});
    }
  }
};